module.exports = __webpack_public_path__ + "img/bgr-tickets.98566a78.png";